var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserManagementIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6016 6.5C15.6016 4.567 14.0346 3 12.1016 3C10.1686 3 8.60156 4.567 8.60156 6.5C8.60156 8.433 10.1686 10 12.1016 10C14.0346 10 15.6016 8.433 15.6016 6.5Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.73V18.92C6 15.65 8.65 13 11.92 13C15.19 13 17.84 15.65 17.84 18.92V20.73",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 15.1802C6.45 15.0302 6.02 14.9502 5.58 14.9502C3.6 14.9502 2 16.5502 2 18.5302",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.6001C6.10457 12.6001 7 11.7047 7 10.6001C7 9.49553 6.10457 8.6001 5 8.6001C3.89543 8.6001 3 9.49553 3 10.6001C3 11.7047 3.89543 12.6001 5 12.6001Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 15.1802C17.5775 15.0302 18.0075 14.9502 18.4475 14.9502C20.4275 14.9502 22.0275 16.5502 22.0275 18.5302",
    stroke: "#EC5F2A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.6001C20.1046 12.6001 21 11.7047 21 10.6001C21 9.49553 20.1046 8.6001 19 8.6001C17.8954 8.6001 17 9.49553 17 10.6001C17 11.7047 17.8954 12.6001 19 12.6001Z",
    stroke: "#EC5F2A",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementIconActive);
export default __webpack_public_path__ + "static/media/userManagementIconActive.8a13c75fd93668b8592791c339742f06.svg";
export { ForwardRef as ReactComponent };